import React, { useState } from "react";
import EntityForm from "../../../modules/entity/forms";
import { useSelector } from "react-redux";
import { Fields } from "../../../uicomponents";
import { Field } from "formik";
import get from "lodash/get";
import Visa from "./image/visa.png";
import UzCard from "./image/uzcard.jpg";
import useTranslation from "hooks/useTranslation";
import { useNavigate } from "react-router-dom";

const PaymentModal = ({ showPaymentModal }) => {
	const { tr } = useTranslation();
	const navigate = useNavigate();

	const organization = useSelector(state => state.auth.selected_organization);
	const [isChecked, setIsChecked] = useState(false);

	return (
		<div>
			<div className="modal-title">{tr("Оплата")}</div>
			<div className="modal-body">
				<EntityForm.Default
					method="post"
					url="/payment/store"
					onSuccess={(response, resetForm) => {
						if (response.data) {
							window.open(response.data, "_blank");
						}
						resetForm();
						showPaymentModal(false);
					}}
					fields={[
						{
							name: "amount",
							required: true
						},
						{
							name: "payment_type",
							required: true
						},
						{
							name: "organization_id",
							value: organization.id,
							required: true
						},
						{ name: "email", required: false },
						{ name: "phone", required: false }
					]}
				>
					{({ isSubmitting, values, setFieldValue }) => {
						return (
							<div className="payment-modal-ui">
								<div className="payment-modal-ui__hero">
									<div className="payment-modal-ui__hero-inner">
										<div className="payment-modal-ui__hero-icon" aria-hidden="true">
											<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="2" y="4" width="20" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
												<path d="M2 9.5h20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
												<rect x="5" y="12.5" width="6" height="4" rx="0.75" fill="currentColor" fillOpacity="0.28" />
												<path d="M14 14h5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.45" />
												<path d="M14 16.5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.35" />
											</svg>
										</div>
										<p className="payment-modal-ui__hero-sub">{tr("Выберите способ оплаты")}</p>
									</div>
								</div>

								<div className="payment-modal-ui__id">
									<span className="payment-modal-ui__id-label">{tr("Payment ID")}</span>
									<div className="payment-modal-ui__id-value" title={String(get(organization, "payment_id") || "")}>
										{get(organization, "payment_id") || "—"}
									</div>
								</div>

								<div className="payment-modal-ui__section">
									<div className="payment-modal-ui__methods" role="radiogroup" aria-label={tr("Тип оплаты")}>
										{[
											{ name: UzCard, id: "uzcard", label: "UzCard / Humo" },
											{ name: Visa, id: "octo", label: "Visa / Mastercard" }
										].map(option => {
											const selected = values.payment_type === option.id;
											return (
												<button
													key={option.id}
													type="button"
													role="radio"
													aria-checked={selected}
													onClick={() => setFieldValue("payment_type", option.id)}
													className={`payment-modal-ui__method ${selected ? "payment-modal-ui__method--active" : ""}`}
												>
													<span className="payment-modal-ui__method-check" aria-hidden="true" />
													<img src={option.name} alt="" className="payment-modal-ui__method-img" />
													<span className="payment-modal-ui__method-caption">{option.label}</span>
												</button>
											);
										})}
									</div>
								</div>

								{values.payment_type === "octo" && (
									<div className="payment-modal-ui__panel">
										<Field
											component={Fields.InputS1}
											name="amount"
											type="number"
											placeholder={tr("Введите сумма")}
											label={tr("Сумма")}
											isRequired={true}
											size={"small"}
											className="mb-0"
										/>
										<a
											href="https://zim-zim.uz/privacy"
											target="_blank"
											rel="noopener noreferrer"
											className="payment-modal-ui__link"
										>
											{tr("Публичная оферта")}
										</a>
										<label className="payment-modal-ui__consent">
											<input
												type="checkbox"
												required={true}
												checked={isChecked}
												onChange={e => setIsChecked(e.target.checked)}
											/>
											<span>{tr("Я ознакомлен публичный оферта")}</span>
										</label>
									</div>
								)}

								<div className="payment-modal-ui__actions">
									<button
										type="submit"
										className={`payment-modal-ui__submit d-btn d-btn-primary flex justify-center items-center ${isSubmitting ? "--loading" : ""}`}
										disabled={isSubmitting}
										onClick={e => {
											if (values.payment_type === "uzcard") {
												e.preventDefault();
												const paymentId = get(organization, "payment_id");

												if (paymentId) {
													navigate(
														"/hamkor-bank?payment_id=" +
														paymentId +
														"&amount=" +
														values.amount
													);
												} else {
													navigate("/hamkor-bank");
												}
												showPaymentModal(false);
											}
										}}
									>
										{tr("Оплатить")}
									</button>
								</div>
							</div>
						);
					}}
				</EntityForm.Default>
			</div>
		</div>
	);
};

export default PaymentModal;
